import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenu } from '@angular/material/menu';
import { SystemPermission } from 'src/app/constants/permissions/system-permission';
import { User } from 'src/app/data/models/user';
import { UserService } from 'src/app/data/user/user.service';
import { Router } from '@angular/router';
import { CreateProjectDialogComponent } from '../create-project-dialog/create-project-dialog.component';
import { ChangeProjectStatusComponent } from '../change-project-status/change-project-status.component';
import { ProjectStatusEnum } from '../../../constants/project-status';
import { Project } from 'src/app/data/models/project';
import { RequestProjectStatusChangeComponent } from '../request-project-status-change/request-project-status-change.component';
import { ProjectService } from 'src/app/data/project/project.service';
import { ProjectsApiService } from 'src/app/api/projects-api.service';
import { SyncService } from 'src/app/api/sync.service';
import { ConfigFabricWorkspaceComponent } from '../config-fabric-workspace/config-fabric-workspace.component';
import { Subscription } from 'rxjs';
import { ToasterService } from '../../../api/toaster.service';
import { CommonMessages } from '../../../constants/common-messages';
import { StringConstants } from '../../../constants/string-constants';

@Component({
    selector: 'app-project-config-menu',
    templateUrl: './project-config-menu.component.html',
    styleUrls: ['./project-config-menu.component.scss'],
    exportAs: 'projectConfigMenu',
    standalone: false
})
export class ProjectConfigMenuComponent implements OnInit, OnDestroy {
  @Input() project: Project;
  @ViewChild(MatMenu, { static: true }) menu!: MatMenu;
  public userProfile!: User;
  permissionEnum = SystemPermission;
  projectStatusEnum = ProjectStatusEnum;
  isProjectAdmin = false;
  showProjectSettingsOption = false;
  isProjectAdminCanRequestArchive: false;
  subscriptions: Subscription[] = [];

  statesForProjectSettingMenuOption: string[] = [
    ProjectStatusEnum.ACTIVE.toString(),
    ProjectStatusEnum.PAUSED.toString(),
    ProjectStatusEnum.COMPLETED.toString(),
    ProjectStatusEnum.CANCELLED.toString(),
  ];

  constructor(
    public projectDataService: ProjectService,
    public projectApiService: ProjectsApiService,
    public syncService: SyncService,
    public userService: UserService,
    public dialog: MatDialog,
    private router: Router,
    private toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    if (!this.userService.userHasPlatformAdminRole) {
      this.project?.projectTeam.forEach((projectUser) => {
        if (projectUser.userId === this.userService.loggedInUser.id && projectUser.isAdmin) {
          this.isProjectAdmin = true;
        }
      });
    }

    const isNotConfigured = this.project.solutionOffering === '';
    this.showProjectSettingsOption =
      this.statesForProjectSettingMenuOption.includes(this.project.status) && !isNotConfigured;
  }

  //TODO: This has to be removed once the Configure Fabric Workspace is implemented
  configureFabricWorkspace(): void {
    const dialogRef = this.dialog.open(ConfigFabricWorkspaceComponent, {
      data: {
        projectId: this.project.projectId,
        projectName: this.project.projectTitle,
        fabricWorkspaceName: this.project.fabricWorkspaceName,
      },
      disableClose: true,
    });

    this.subscriptions.push(
      dialogRef.afterClosed().subscribe((data) => {
        if (data) {
          this.syncService.refreshProjectList.next(true);
        }
      })
    );
  }

  executeFabricWorkspace(): void {
    this.subscriptions.push(
      this.projectApiService.executeFabricWorkspace(this.project.projectId).subscribe({
        next: () => {
          this.syncService.refreshProjectList.next(true);
        },
      })
    );
    this.toasterService.info(CommonMessages.EXECUTE_FABRIC_WORKSPACE_PROCESSING, StringConstants.SUCCESS);
  }

  openChangeProjectStatusDialog(): void {
    this.dialog.open(ChangeProjectStatusComponent, {
      data: {
        projectId: this.project.projectId,
        projectName: this.project.projectTitle,
        projectStatus: {
          id: this.project.statusId,
          name: this.project.status,
        },
      },
      disableClose: true,
      width: '40%',
    });
  }

  openProjectConfigurationPage(): void {
    this.router.navigateByUrl(`project-configuration/${this.project.projectId}`);
  }

  openProjectConfigurationSummaryPage(): void {
    this.router.navigateByUrl(`project-configuration/summary/${this.project.projectId}`);
  }

  openProjectSettingsPage(): void {
    sessionStorage.setItem('projectName', this.project.projectTitle);
    this.router.navigateByUrl(`project/${this.project.projectId}/project-settings`);
  }

  openEditProjectDialog(): void {
    this.dialog.open(CreateProjectDialogComponent, {
      minHeight: '100vh',
      height: '100%',
      width: '43.75rem',
      position: { right: '0', top: '0' },
      panelClass: ['sidebar-dialog', 'animate__animated', 'animate__slideInRight', 'animate__faster'],
      data: { projectId: this.project.projectId, isProjectAdmin: this.isProjectAdmin },
      disableClose: true,
    });
  }

  openProjectStatusChangeRequestDialog(): void {
    this.dialog.open(RequestProjectStatusChangeComponent, {
      data: {
        projectId: this.project.projectId,
        projectName: this.project.projectTitle,
        projectStatus: {
          id: this.project.statusId,
          name: this.project.status,
        },
      },
      disableClose: true,
      width: '40%',
    });
  }

  ngOnDestroy(): void {
    // unsubscribing in ngOnDestroy
    this.subscriptions?.forEach((s) => s.unsubscribe());
  }


  showHideRemoveAndChangeProjectStatusMenu(): boolean {
    if (this.userService.userHasPlatformAdminRole) {
      if (this.project.status === this.projectStatusEnum.CREATED.toString()) {
        if ( !this.project.doesFabricJobExist && !this.project.fabricWorkspaceExecuted) {
          return true;
        }
        else {
          return false;
        }
      }     
      else {
        return true;
      }
    }
    else {
      return false;
    }
  }
}
